module.exports = "/_next/static/images/Privacy-xs@2x-40d7be3e3cfac5bbfde3c625a191c764.webp";